import { useMemo, useState } from "react";
import { BucketRow } from "../data-model/bucketModel";

export interface UseBucketFiltersResult {
  search: string;
  setSearch: (s: string) => void;
  filteredRows: BucketRow[];
}

export const useBucketFilters = (rows: BucketRow[]): UseBucketFiltersResult => {
  const [search, setSearch] = useState("");

  const filteredRows = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter((r) => r.name.toLowerCase().includes(q));
  }, [rows, search]);

  return { search, setSearch, filteredRows };
};
